import React, { useState, useEffect } from "react";
import useSalesReceiptStore from "../store";
import { Dropdown, Table } from "react-bootstrap";
import { findNameById } from "../../Utility/findNameById";
import HierarchicalDropdown from "../../Common/HierarchicalDropdown";
import { useParams, useSearchParams } from "react-router-dom";
import { Save2Fill } from "react-bootstrap-icons";
import { Spinner, Button, Modal, Accordion, ListGroup } from "react-bootstrap";
import { useMutation } from "@tanstack/react-query";
import { ToastContainer, toast } from "react-toastify";
import {
  updatePaidIns,
  updatePaidOuts,
  getRestaurantDetails,
  useSyncPaidInsAndOuts,
  useFetchAllChartOfAccounts,
} from "../api";
import axios from "axios";
export default function PaidInsAndOuts({ type }) {
  const {
    paidIns,
    paidOuts,
    setPaidIns,
    setPaidOuts,
    paidInOutId,
    isPaidInOutSynced,
    paidInOutSyncedAt,
    paidInOutSyncLogs,
  } = useSalesReceiptStore();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [restaurantDetails, setRestaurantDetails] = useState({});
  const [restaurantDetailsLoading, setRestaurantDetailsLoading] =
    useState(false);
  const date = searchParams.get("date");
  const { data: allChartOfAccounts = [] } = useFetchAllChartOfAccounts(id);
  const [clickBaconCoa, setClickBaconCoa] = useState([]);
  const [baconLoading, setBaconLoading] = useState(false);
  const [replaceExisting, setReplaceExisting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { mutate, isPending } = useMutation({
    mutationFn: type === "Paid Ins" ? updatePaidIns : updatePaidOuts,
    onSuccess: (data) => {
      toast.success(data.message);
    },
    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });

  const { mutate: syncPaidInsAndOuts, isPending: syncing } =
    useSyncPaidInsAndOuts();

  const handleSyncPaidInsAndOuts = async () => {
    const body = {
      restaurant_id: id,
      report_date: date,
      sync_mode: "qbo",
      force_sync: isPaidInOutSynced ? true : false,
      replace_existing: replaceExisting,
    };
    syncPaidInsAndOuts(body);
    setReplaceExisting(false);
    setShowModal(false);
  };

  useEffect(() => {
    const fetchClickBaconCoa = async (id) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_CLICKBACON_URL}/backend/utils/categories`,
          {
            restaurantId: id,
          },
          {
            headers: {
               Authorization: `Bearer ${process.env.REACT_APP_CLICKBACON_TOKEN}`
            },
          }
        );

        let cats = response?.data?.data;
        setClickBaconCoa(cats.laborCategories);
        setBaconLoading(false);
      } catch (error) {}
    };
    fetchClickBaconCoa(id);
  }, []);

  useEffect(() => {
    setRestaurantDetailsLoading(true);
    getRestaurantDetails(id)
      .then((data) => {
        setRestaurantDetails(data?.restaurant_details);
        setRestaurantDetailsLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, []);

  if (type === "Paid Ins" && paidIns.length === 0) {
    return null;
  }
  if (type === "Paid Outs" && paidOuts.length === 0) {
    return null;
  }

  return (
    <div className="mx-3 my-3 border-white rounded shadow-sm p-3">
      <ToastContainer />
      <div className="d-flex mb-0 justify-content-between">
        <h4>{type}</h4>
        {!isPending ? (
          <Save2Fill
            fill="gray"
            width="25"
            height="25"
            style={{ cursor: "pointer" }}
            className="mx-2"
            onClick={() => {
              let payload =
                type === "Paid Ins"
                  ? { restaurant_id: id, report_date: date, paid_ins: paidIns }
                  : {
                      restaurant_id: id,
                      report_date: date,
                      paid_outs: paidOuts,
                    };
              mutate(payload);
            }}
          />
        ) : (
          <Spinner animation="border" className="mx-2" size="sm" />
        )}
      </div>
      <Table striped bordered hover responsive className="table-stack">
        <thead>
          <tr>
            <th>Employee</th>
            <th>Description</th>
            <th>Time</th>
            <th>Amount</th>
            <th>
              {restaurantDetailsLoading && "Loading..."}
              {!restaurantDetailsLoading &&
              restaurantDetails?.["use_qbo"] === false &&
              restaurantDetails?.["use_clickbacon"] === true
                ? "clickBACON Mapping"
                : "QBO Mapping"}
            </th>
          </tr>
        </thead>
        <tbody>
          {type === "Paid Ins" &&
            paidIns?.map((item, index) => (
              <tr key={index}>
                <td data-label="Employee">{item["Employee"]}</td>
                <td data-label="Description" style={{ textTransform: "capitalize" }}>
                  {item["Description"]}
                </td>
                <td data-label="Time">{item["Time"]}</td>
                <td data-label="Amount">{item["Amount"]}</td>
                <td data-label="Mapping" className="stack-full">
                  {restaurantDetailsLoading && "Loading..."}
                  {!restaurantDetailsLoading &&
                  restaurantDetails?.["use_qbo"] === false &&
                  restaurantDetails?.["use_clickbacon"] === true ? (
                    <Dropdown
                      onSelect={(e) => {
                        let newPaidIns = [...paidIns];
                        newPaidIns[index]["coa_id"] = e;
                        setPaidIns(newPaidIns);
                      }}
                      style={{ width: "100%" }}
                    >
                      <Dropdown.Toggle
                        variant="light"
                        id="dropdown-basic"
                        style={{ width: "100%", textAlign: "left" }}
                      >
                        {clickBaconCoa.find(
                          (item) => item.id === paidIns[index]["coa_id"]
                        )?.name || "Select a Category"}
                      </Dropdown.Toggle>

                      <Dropdown.Menu style={{ width: "100%" }}>
                        {clickBaconCoa.map((item) => (
                          <Dropdown.Item eventKey={item.id} key={item.id}>
                            {item.name}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : (
                    <HierarchicalDropdown
                      data={allChartOfAccounts}
                      togglerText={findNameById(
                        allChartOfAccounts,
                        item["coa_id"]
                      )}
                      onClickFunction={(item) => {
                        let newPaidIns = [...paidIns];
                        newPaidIns[index]["coa_id"] = item.Id;
                        setPaidIns(newPaidIns);
                      }}
                    />
                  )}
                </td>
              </tr>
            ))}
          {type === "Paid Outs" &&
            paidOuts?.map((item, index) => (
              <tr key={index}>
                <td data-label="Employee">{item["Employee"]}</td>
                <td data-label="Description" style={{ textTransform: "capitalize" }}>
                  {item["Description"]}
                </td>
                <td data-label="Time">{item["Time"]}</td>
                <td data-label="Amount">{item["Amount"]}</td>
                <td data-label="Mapping" className="stack-full">
                  {restaurantDetailsLoading && "Loading..."}
                  {!restaurantDetailsLoading &&
                  restaurantDetails?.["use_qbo"] === false &&
                  restaurantDetails?.["use_clickbacon"] === true ? (
                    <Dropdown
                      onSelect={(e) => {
                        let newPaidOuts = [...paidOuts];
                        newPaidOuts[index]["coa_id"] = e;
                        setPaidOuts(newPaidOuts);
                      }}
                      style={{ width: "100%" }}
                    >
                      <Dropdown.Toggle
                        variant="light"
                        id="dropdown-basic"
                        style={{ width: "100%", textAlign: "left" }}
                      >
                        {clickBaconCoa.find(
                          (item) => item.id === paidOuts[index]["coa_id"]
                        )?.name || "Select a Category"}
                      </Dropdown.Toggle>

                      <Dropdown.Menu style={{ width: "100%" }}>
                        {clickBaconCoa.map((item) => (
                          <Dropdown.Item eventKey={item.id} key={item.id}>
                            {item.name}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : (
                    <HierarchicalDropdown
                      data={allChartOfAccounts}
                      togglerText={findNameById(
                        allChartOfAccounts,
                        item["coa_id"]
                      )}
                      onClickFunction={(item) => {
                        let newPaidOuts = [...paidOuts];
                        newPaidOuts[index]["coa_id"] = item.Id;
                        setPaidIns(newPaidOuts);
                      }}
                    />
                  )}
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
      {type === "Paid Outs" && (
        <div className="d-flex border-gray">
          <div style={{ width: "50%" }}>
            <Accordion className="my-4">
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  Paid Ins & Paid Outs Sync Logs
                </Accordion.Header>
                <Accordion.Body>
                  <ListGroup variant="flush">
                    {paidInOutSyncLogs?.map((log, index) => (
                      <ListGroup.Item
                        key={index}
                        className={`bg-dark ${
                          log.log_level === "ERROR"
                            ? "text-danger"
                            : log.log_level === "WARNING"
                            ? "text-warning"
                            : "text-white"
                        }`}
                      >
                        {log.timestamp} - {log.message}
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
          <div style={{ width: "10%" }} className="mx-1">
            <label>Synced</label>
            <input
              type="text"
              className="form-control"
              disabled
              value={isPaidInOutSynced ? "Yes" : "False"}
            />
          </div>
          <div style={{ width: "20%" }} className="mx-1">
            <label>Synced At</label>
            <input
              type="text"
              className="form-control"
              disabled
              value={paidInOutSyncedAt}
            />
          </div>
          <div style={{ width: "20%" }} className="mx-1 my-4">
            <button
              style={{ width: "100%" }}
              className="btn-primary btn"
              onClick={() => {
                if (isPaidInOutSynced === true) {
                  setShowModal(true);
                } else {
                  handleSyncPaidInsAndOuts();
                }
              }}
              disabled={syncing}
            >
              {syncing ? "Syncing..." : "Sync"}
            </button>
          </div>
        </div>
      )}

      <Modal
        show={showModal}
        onHide={() => {
          setReplaceExisting(false);
          setShowModal(false);
        }}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Already Synced
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6>Do you want to</h6>
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="flexRadioDefault"
              id="flexRadioDefault1"
              checked={!replaceExisting}
              onChange={() => {
                setReplaceExisting(false);
              }}
            />
            <label className="form-check-label" htmlFor="flexRadioDefault1">
              Create Duplicate
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="flexRadioDefault"
              id="flexRadioDefault2"
              x
              checked={replaceExisting}
              onChange={() => {
                setReplaceExisting(!replaceExisting);
              }}
            />
            <label className="form-check-label" htmlFor="flexRadioDefault2">
              Replace Existing
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleSyncPaidInsAndOuts} disabled={syncing}>
            {syncing ? "Processing ..." : "Sync"}
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              setReplaceExisting(false);
              setShowModal(false);
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
